import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import ProjectTable from './ProjectTable';
import CreateProjectModal from './create-project';
import GreetingCard from './GreetingCard';

const LandDev = () => {
  const [createProjectModalVisible, setCreateProjectModalVisible] =
    useState(false);

  const toggleModal = () => {
    setCreateProjectModalVisible(prevVisible => !prevVisible);
  };

  return (
    <>
      <GreetingCard />
      <Card>
        <Card.Body>
          <ProjectTable toggleModal={toggleModal} />
        </Card.Body>
      </Card>

      <CreateProjectModal
        show={createProjectModalVisible}
        onClose={toggleModal}
      />
    </>
  );
};

export default LandDev;
